import {InformationScaleRoot} from './components/information-scale-root';
import {Progress} from './varinat/progress';

export const InformationScale = Object.assign(InformationScaleRoot, {
	Progress,
});
